import { CompanionRule } from '../companion-rule.model';
import { CompanionRuleActions, CompanionRuleActionTypes } from '../actions/companion-rule.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: any;
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: null
};

export function reducer(state: State = initialState, action: CompanionRuleActions): State {

  switch (action.type) {
    case CompanionRuleActionTypes.GetCompanionRuleList: {
      return {...state, Loaded: false, Loading: true};
    }

    case CompanionRuleActionTypes.UpsertCompanionRuleList: {
      return  {...state, Loaded: true, Loading: false, entities: action.payload};
    }

    case CompanionRuleActionTypes.GetCompanionRuleListFail: {
      return {...state, Loaded: true, Loading: false};
    }

    case CompanionRuleActionTypes.NoCompanionRuleList: {
      return {...state, Loaded: true, Loading: false};
    }

    case CompanionRuleActionTypes.UpdateCompanionRule: {
      return {...state, Loaded: false, Loading: true};
    }

    case CompanionRuleActionTypes.UpdateCompanionRuleFail: {
      return {...state, Loaded: true, Loading: false};
    }

    default:

    return state;
  }
}

